import {setDialog, setSnackbar, setUser} from "./globalAction";

export const globalReducer = (state: any, action: any) => {
    switch (action.type) {
        case setSnackbar:
            return {
                ...state,
                snackbar: action.payload.snackbar
            }
        case setUser:
            return {
                ...state,
                user: action.payload.user
            }
        case setDialog:
            return {
                ...state,
                dialog: action.payload.dialog
            }
        default:
            return state;
    }
}
